import { baseApi } from './base';
import { SkillCategory } from '../../types/interfaces';

export const getSkillCategories = async () => {
  const response = await baseApi.get<SkillCategory[]>(`/v1/public/skill-category`);

  return response.data;
};
